import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventsMultipleChoice } from '../../../../questiontype/MultipleChoice/registry/EventsMultipleChoice';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryQuestion extends EventRegistryCategory {
    label = 'Question';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_multiplechoice = new EventsMultipleChoice(this);
    questioncomplete = () => new EventRegistryItem({ handlerName: 'onQuestionComplete' });
    questionfinish = () => new EventRegistryItem({ handlerName: 'onQuestionFinish' });
    stepcomplete = () => new EventRegistryItem({ handlerName: 'onStepComplete' });
}
